import { z } from 'zod';
import {
  EMPTY_FIELD_MESSAGE,
  validateSpace,
  validateTextEn,
} from '@Utils/validation';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

enum OPERATION_INCOME_MODAL_MESSAGE {
  NAME = 'กรุณาระบุชื่อรายได้อื่นจากการดำเนินงาน',
  NAME_EN = 'กรุณาระบุชื่อรายได้อื่นจากการดำเนินงานเป็นภาษาอังกฤษ',
}

enum NON_OPERATION_INCOME_MODAL_MESSAGE {
  NAME = 'กรุณาระบุชื่อรายได้อื่นนอกเหนือจากการดำเนินงาน',
  NAME_EN = 'กรุณาระบุชื่อรายได้อื่นนอกเหนือจากการดำเนินงานเป็นภาษาอังกฤษ',
}

export const OtherIncomeModalSchema = (subgroup: INCOME_SUBGROUP_CATEGORY) => {
  const message =
    subgroup === INCOME_SUBGROUP_CATEGORY.OTHER_OPERATION_INCOME
      ? OPERATION_INCOME_MODAL_MESSAGE
      : NON_OPERATION_INCOME_MODAL_MESSAGE;

  return z.object({
    nameTh: z
      .string({ message: message.NAME })
      .min(1, { message: message.NAME })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
    nameEn: z
      .string({ message: message.NAME })
      .min(1, { message: message.NAME })
      .regex(validateTextEn, {
        message: message.NAME_EN,
      })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  });
};
